module.exports = __webpack_public_path__ + "static/media/staff1.85c0604a.png";